import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const setDefaultAccount = paymentCredentialsId =>
  call(websocketFetch, 'set_default_payee_payment_credentials', {
    payment_credentials_id: paymentCredentialsId,
  });
